import axios, { AxiosError } from 'axios'
import type { AppNotification } from '../../pages/social/types'

const api = axios.create({ baseURL: `${import.meta.env.VITE_APP_BASE_API_URL}/v1/notifications` })

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('userToken')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ error?: { message?: string } }>) =>
    Promise.reject(new Error(error.response?.data?.error?.message || error.message)),
)

export const getNotifications = async (params: { unread?: boolean; limit?: number; before?: string } = {}) =>
  (await api.get<{ data: { items: AppNotification[]; unread: number } }>('/', { params })).data.data

export const getUnreadCount = async () =>
  (await api.get<{ data: { unread: number } }>('/unread-count')).data.data.unread

export const markNotificationRead = async (id: string) =>
  (await api.post<{ data: AppNotification }>(`/${id}/read`)).data.data

export const markAllNotificationsRead = async () => api.post('/read-all')
